export const searchBy = {
  MEETINGS: 'meetings',
  FILES: 'files',
  REPORTS: 'reports',
  MEMBERS: 'members',
};
